export default __webpack_public_path__ + "fonts/dotted-yellow-scratch-SP.svg";